module.exports = __webpack_public_path__ + "static/media/about-content.570bd3aa.jpg";